import React, { useContext } from "react";
// @material-ui/core components
import { makeStyles, Button, Typography } from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import { defaultFont } from "assets/jss/material-dashboard-react.js";
import Edit from "@material-ui/icons/Edit";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import RecordsMenu from "components/Menus/RecordsMenu.js";
//other imports
import firebase from '../firebase/config';
import { Link } from 'react-router-dom'
// Context
import { UserContext } from 'context/userContext'
// instantsearch
import {
  InstantSearch, SearchBox, connectInfiniteHits, Stats,
  Highlight, Configure
} from "react-instantsearch-dom"
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter"
import { CompareSharp } from "@material-ui/icons";


const useStyles = makeStyles(theme => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  card: {
    background: 'white',
    [theme.breakpoints.down("xs")]: {
      minWidth: '95vw',
      position: 'relative',
      right: 20,
      padding: '-15px',
    },
  },
  table: {
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse"
  },
  tableHeadCell: {
    color: "inherit",
    ...defaultFont,
    "&, &$tableCell": {
      fontSize: "1em"
    }
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "12px 8px",
    verticalAlign: "middle",
    fontSize: "0.8125rem",

  },
  firstCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "12px 8px",
    verticalAlign: "middle",
    fontSize: "0.8125rem",
    [theme.breakpoints.down("xs")]: {
      textAlign: 'center',
      maxWidth: 36,
    },
  },
  tableResponsive: {
    width: "100%",
    marginTop: theme.spacing(2),
    overflowX: "auto"
  },
  tableHeadRow: {
    height: "56px",
    color: "inherit",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle"
  },
  tableBodyRow: {
    height: "48px",
    color: "inherit",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle"
  },
  centered: {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '4px',
  },
  linkBox: {
    margin: 10,
    display: 'flex',
    justifyContent: 'center',
  },
}))

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey: "45nEutOZi9X5I3wFsRFJlz6XulZUjB7Y",
    nodes: [
      {
        host: 'yhnf9o3sdljacmbvp-1.a1.typesense.net',
        port: '443',
        protocol: 'https'
      },
    ],
  },
  additionalSearchParameters: {
    queryBy: "nome",
  },
})
const searchClient = typesenseInstantsearchAdapter.searchClient

export default function Search(props) {
  const classes = useStyles()
  const hitsPerPage = 30
  let isGroupSearch = props.location.pathname === "/groupsearch"

  const { currentUser, userProfile, isPro, groupName, recordsCount } = useContext(UserContext)

  const InfiniteHits = ({ hits, hasMore, refineNext }) => (
    <div>
      <div className={classes.tableResponsive}>
        <Table className={classes.table}>
          <TableHead className={classes.primaryTableHeader}>
            <TableRow className={classes.tableHeadRow}>
              {["Data", "Nome", "Idade", "Editar", "Opções"].map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {hits.map((hit, key) => {
              const newData = (typeof hit.data === "object" && "_seconds" in hit.data && "_nanoseconds" in hit.data)
                ? new firebase.firestore.Timestamp(hit.data._seconds, hit.data._nanoseconds)
                : firebase.firestore.Timestamp.fromMillis(hit.data * 1000);
              return (
                <TableRow key={key} className={classes.tableBodyRow}>
                  <TableCell className={classes.firstCell}>{newData.toDate().toLocaleDateString()}</TableCell>
                  <TableCell className={classes.tableCell}><Highlight attribute="nome" hit={hit} tagName="mark" /></TableCell>
                  <TableCell className={classes.tableCell}>{hit.idade}</TableCell>
                  <TableCell className={classes.tableCell}>
                    <Link to={{
                      pathname: '/new', state: {
                        ...hit,
                        data: newData.toDate(),
                      }
                    }}>
                      <Edit className={classes.icons} fontSize="small" color="action" />
                    </Link>
                  </TableCell>
                  <TableCell className={classes.tableCell}><RecordsMenu ficha={{ ...hit, data: newData, }} /></TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>
      <Button variant="outlined" className={classes.centered} color="primary" disabled={!hasMore} onClick={refineNext}>
        Visualizar Próximos
      </Button>
    </div>

  );

  const CustomInfiniteHits = connectInfiniteHits(InfiniteHits);

  return (
    <div className={classes.root}>
      {!userProfile && (<MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
        É muito importante que seu perfil seja preenchido! Clique no item "Perfil" no menu lateral.
      </MuiAlert>
      )}
      {(!isPro && recordsCount > 5 && recordsCount < 12) && (<MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
        Assine o Plano Pro e desfrute do uso ilimitado de todas as nossas funcionalidades.
      </MuiAlert>
      )}
      {(!isPro && recordsCount > 14 && recordsCount < 20) && (<MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
        Resta(m) apenas {20 - recordsCount} ficha(s) na sua cota gratuita. Assine o PRO agora para usar a ferramenta de modo ilimitado.
      </MuiAlert>
      )}
      {(!isPro && recordsCount >= 20) && (<MuiAlert className={classes.alert} elevation={6} variant="filled" severity="error">
        Você excedeu sua cota gratuita. Assine o PRO agora para realizar atendimentos ilimitados.
      </MuiAlert>
      )}
      {(<MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
        Caso esteja com dificuldades em encontrar o paciente, vá menu "Fichas Atendidas" e use Control + F.
      </MuiAlert>
      )}
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card className={classes.card}>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>{isGroupSearch ? "Pesquisar Pacientes do Grupo" : "Pesquisar Meus Pacientes"}</h4>
              <p className={classes.cardCategoryWhite}>
                Exibindo os últimos atendimentos. Para pesquisar um paciente específico,
                digite o nome no campo abaixo
              </p>
            </CardHeader>
            <CardBody>
              <InstantSearch searchClient={searchClient} indexName="ficha">
                <Configure hitsPerPage={hitsPerPage} facetFilters={isGroupSearch ? [`groupName:${groupName}`] : [`user:${currentUser.uid}`]} />
                <SearchBox showLoadingIndicator className={classes.centered}
                  translations={{
                    submitTitle: 'Pesquisar',
                    resetTitle: 'Limpar pesquisa',
                    placeholder: 'Digite o nome do paciente',
                  }}
                />
                <Stats className={classes.centered} translations={{ stats(nbHits) { return `${nbHits.toLocaleString()} pacientes encontrados ` } }} />
                <CustomInfiniteHits />
              </InstantSearch>
            </CardBody>
            <Link to={isGroupSearch ? '/group' : '/records'} className={classes.linkBox}>
              <Typography variant="caption">Problemas com visualização de pacientes? Recarregar lista de pacientes</Typography>
            </Link>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
